import { DateFns } from '@/shared/date-fns';
import { DomainBaseComponent } from '@/shared/domain-base.component';
import { EmailService } from '@/shared/email.service';
import { UtilFns } from '@/shared/util-fns';
import { ShippingService } from '@/shipping/shipping.service';
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Account, ReturnRequestDetail } from 'app/model/entities/entity-model';
import { DomainService } from 'app/shared/domain.service';
import { sum } from 'lodash';

/** similar to printable-invoice-content component */
interface FlatDetail {
  // mfr: string;
  employee: string;
  desc: string;
  ptConfigName: string;
  featureChoicesExtract: string;
  qty: number;
  unitPrice: string;
  total: string;
}

@Component({
    templateUrl: './restock-fee-invoice.component.html',
    selector: 'app-restock-fee-invoice',
    standalone: false
})
export class RestockFeeInvoiceComponent extends DomainBaseComponent implements OnInit, OnDestroy {
  @Input("account") account: Account;
  @Input("returnRequestDetails") returnRequestDetails: ReturnRequestDetail[];

  flatDetails: FlatDetail[];
  billingAddress: string;
  shippingAddress: string;
  billingEmail: string;
  invoiceNumber: string;
  invoiceDate: Date;
  dueDate: Date;
  poNumber: string;
  totalAmt: number;

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute,

    private emailService: EmailService,
    private shippingService: ShippingService,
    private elementRef: ElementRef
  ) {
    super(domainService);
    // this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
    //   this.updateFromContext();
    // });
  }

  ngOnInit(): void {
    this.updateFromContext();
  }

  private async updateFromContext() {
    const fmtCurrency = UtilFns.fmtCurrency;

    const rrds = this.returnRequestDetails;
    if (!rrds?.length) {
      this.flatDetails = [];
      return;
    }

    const rrd = rrds.find(x => !!x.joDetail.joHeader.customerPurchaseOrderNumber) || rrds[0];
    const jo = rrd.joDetail.joHeader;
    this.billingAddress = UtilFns.getAddress(jo, "billing", false, false);
    this.shippingAddress = UtilFns.getAddress(jo, "shipping", false, false);
    this.billingEmail = jo.billingEmail || this.account.invoiceEmail;
    this.invoiceNumber = RestockFeeInvoiceComponent.getInvoiceName(rrds);
    this.invoiceDate = new Date();
    this.dueDate = DateFns.dateAdd(this.invoiceDate, this.account.dueDateNumDays || 30, 'day');
    this.poNumber = jo.customerPurchaseOrderNumber;

    this.flatDetails = rrds.map(d => {
      const jod = d.joDetail;
      const style = jod.product.productType;
      const ptConfigName = jod.productTypeConfigName;
      const f: FlatDetail = {
        employee: jo.getFormalEmployeeName(),
        desc: style.description,
        ptConfigName: ptConfigName,
        featureChoicesExtract: jod.product.getFeatureChoicesExtract(),
        qty: d.qty,
        unitPrice: fmtCurrency(jod.unitRestockAmt),
        total: fmtCurrency(jod.unitRestockAmt * d.qty),
      };
      return f;
    });

    const total = sum(rrds.map(x => x.joDetail.unitRestockAmt * x.qty));
    this.totalAmt = +total.toFixed(2);
      
    this.isPageReady = true;
  }

  static getInvoiceName(rrds: ReturnRequestDetail[]) {
    if (!rrds?.length) {
      return 'ERROR';
    }
    return 'RESTOCK-' + rrds[0].id;
  }
}
